// Copyright (c) Meta Platforms, Inc. and affiliates.

'use client';

/**
 * @file index.ts
 * @input Imports from Spinner component
 * @output Exports Spinner component and related types
 * @position Entry point for Spinner; re-exported by /packages/core/src/index.ts
 *
 * SYNC: When modified, update this header and /packages/core/src/Spinner/Spinner.doc.mjs
 */
export { Spinner } from "./Spinner.js";